import PageNotFound from '../Components/PageNotFound/PageNotFound';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';

export default function AdminProtectedRoute({ children }) {
  const token = sessionStorage.getItem('adminToken');

  if (!token) {
    return (
      <>
        <Navbar />
        <main className="main-content-wrapper">
          <PageNotFound />
        </main>
        <Footer />
      </>
    );
  }

  return children;
}